// Imports des librairies et composants
import React, { useState, useEffect } from 'react';
import Login from './components/Login.js';
import Dashboard from './components/Dashboard.js';
import './styles/App.css';

// Composant principal de l'application
function App() {
  // Récupère le token depuis le localStorage pour vérifier si l'utilisateur est connecté
  const [token, setToken] = useState(localStorage.getItem('user_token'));
  
  // Gestion du scroll : bloqué sur la page login, activé sur le dashboard
  useEffect(() => {
    if (!token) {
      document.body.classList.add('no-scroll'); // Pas de scroll sur login
    } else {
      document.body.classList.remove('no-scroll'); // Scroll activé sur dashboard
    }
  }, [token]);
  
  // Affiche Login si pas connecté, sinon affiche Dashboard
  if (!token) return <Login setToken={setToken} />;
  return <Dashboard setToken={setToken} />;
}

export default App;